import { render, staticRenderFns } from "./__order_channel_form.vue?vue&type=template&id=56e294f2&scoped=true&"
import script from "./__order_channel_form.vue?vue&type=script&lang=js&"
export * from "./__order_channel_form.vue?vue&type=script&lang=js&"
import style0 from "./__order_channel_form.vue?vue&type=style&index=0&id=56e294f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e294f2",
  null
  
)

export default component.exports